<template>
  <div>
    <a-form class="ant-advanced-search-form" :form="fleetSearchForm" @submit="handleFleetSearch">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="Company">
            <a-select v-decorator="['company']" :allowClear="true" placeholder="Select company">
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="16" :style="{ textAlign: 'right' }">
          <a-form-item>
            <a-button type="primary" html-type="submit" icon="search">
              Search Fleets
            </a-button>
            <a-button
              type="primary"
              @click="() => (this.createFleetModalVisible = true)"
              :style="{ marginLeft: '8px' }"
              icon="plus"
            >
              Create New Fleet
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <br />
    <div class="search-result-list">
      <a-table
        :columns="fleetColumns"
        :dataSource="handleFleetData"
        :scroll="{ x: 1500, y: 1000 }"
        :loading="fleetDataLoading"
        :rowKey="record => record.entityId"
        :pagination="{
          defaultPageSize: 10,
          showSizeChanger: true,
          position: 'both'
        }"
        bordered
      >
        <span slot="actions" slot-scope="fleetRecord">
          <a @click="setAddBusFormModal(fleetRecord)">Add Buses</a>
          <a-divider type="vertical" />
          <span v-if="fleetRecord.isActive === true">
            <a-popconfirm okText="Yes" cancelText="No" @confirm="updateIsActive(fleetRecord, false)">
              <template slot="title">
                <p style="margin:0">
                  Are you sure you want to
                  <span style="color:#f50">disable</span> this fleet?
                </p>
              </template>
              <a>Disable</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-popconfirm ok-text="Yes" cancel-text="No" @confirm="updateIsActive(fleetRecord, true)">
              <template slot="title">
                <p style="margin:0">
                  Are you sure you want to
                  <span style="color:#f50">enable</span> this fleet?
                </p>
              </template>
              <a>Enable</a>
            </a-popconfirm>
          </span>
        </span>
        <template slot="expandedRowRender" slot-scope="fleetRecord">
          <a-table
            :columns="innerFleetColumns"
            :dataSource="
              [...fleetRecord.busList].sort((recordOne, recordTwo) => recordOne.busNumber - recordTwo.busNumber)
            "
            :pagination="false"
            :rowKey="busRecord => busRecord.entityId"
          >
            <span slot="actions" slot-scope="busRecord">
              <a-popconfirm ok-text="Yes" cancel-text="No" @confirm="deleteBus(fleetRecord, busRecord)">
                <template slot="title">
                  <p style="margin:0">
                    Are you sure you want to
                    <span style="color:#f50">delete</span> this bus?
                  </p>
                </template>
                <a>Delete</a>
              </a-popconfirm>
              <a-divider type="vertical" />
              <a @click="setEditBusFormModal(fleetRecord, busRecord)">Edit</a>
            </span>
          </a-table>
        </template>
        <span slot="footer">
          {{ this.fleetEntriesFound + " Fleet(s) Found" }}
        </span>
      </a-table>
      <a-modal
        v-model="addBusModalVisible"
        title="Add Buses"
        centered
        :afterClose="
          () => {
            this.addBusForm.resetFields();
            this.uploadFileList = [];
            this.uploadButtonDisabled = false;
          }
        "
      >
        <a-form layout="vertical" id="addBusForm" :form="addBusForm" @submit="addBuses">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item label="Fleet Name">
                <a-input
                  v-decorator="[
                    'fleetName',
                    {
                      initialValue: addBusFormInitialValues.fleetName
                    }
                  ]"
                  :disabled="true"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item>
                <span slot="label"
                  >Buses to Add
                  <a-popover title="Bus List Format">
                    <template slot="content">
                      <p>Please provide the list of buses as a JSON Array. For example:</p>
                      <p>[ { "busNumber": 285, "vin": 12345678901234568 } ]</p>
                      <p><b>Required Attributes:</b> busNumber, vin</p>
                      <p>
                        <b>TIP:</b> Convert CSV to JSON
                        <a href="https://csvjson.com/csv2json" target="_blank" rel="noopener noreferrer">
                          here.
                        </a>
                      </p>
                    </template>
                    <a-icon type="question-circle-o" />
                  </a-popover>
                </span>
                <a-textarea
                  allowClear
                  placeholder="JSON Bus List"
                  :auto-size="{ minRows: 5, maxRows: 10 }"
                  v-decorator="[
                    'busList',
                    {
                      rules: [
                        {
                          validator: customAddFormValidator
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item style="text-align: center">
                <a-upload
                  accept=".csv"
                  :headers="headers"
                  :customRequest="dummyUploadRequest"
                  @change="handleUploadChange"
                  :fileList="uploadFileList"
                  :multiple="false"
                >
                  <a-button icon="upload" :disabled="uploadButtonDisabled">Upload CSV</a-button>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item style="text-align: center">
                <a-button
                  icon="plus"
                  @click="
                    () => {
                      addIndividualBusModalVisible = true;
                    }
                  "
                  >Add Single Bus</a-button
                >
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <template slot="footer">
          <a-button form="addBusForm" type="primary" html-type="submit" :loading="addBusFormButtonLoading">
            Add Buses
          </a-button>
        </template>
      </a-modal>
      <a-modal
        v-model="addIndividualBusModalVisible"
        title="Add Single Bus"
        centered
        :afterClose="
          () => {
            this.addIndividualBusForm.resetFields();
          }
        "
      >
        <a-form id="addIndividualBusForm" :form="addIndividualBusForm" @submit="addIndividualBus">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="Bus Number">
                <a-input
                  v-decorator="[
                    'busNumber',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please enter a bus number!'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="VIN">
                <a-input
                  v-decorator="[
                    'vin',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please enter a VIN!'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <template slot="footer">
          <a-button form="addIndividualBusForm" type="primary" html-type="submit">
            Add Bus
          </a-button>
        </template>
      </a-modal>
      <a-modal
        v-model="editBusModalVisible"
        title="Edit Bus Record"
        centered
        :afterClose="
          () => {
            editBusForm.resetFields();
            editBusFormInitialValues = {};
          }
        "
      >
        <a-form layout="vertical" id="editBusForm" :form="editBusForm" @submit="editBus">
          <a-form-item label="Fleet Name">
            <a-input
              v-decorator="[
                'fleetName',
                {
                  initialValue: editBusFormInitialValues.fleetName
                }
              ]"
              :disabled="true"
            />
          </a-form-item>
          <a-form-item label="Bus Number">
            <a-input
              v-decorator="[
                'busNumber',
                {
                  rules: [
                    {
                      validator: customEditFormValidator
                    }
                  ],
                  initialValue: editBusFormInitialValues.busNumber
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="VIN">
            <a-input
              v-decorator="[
                'vin',
                {
                  rules: [
                    {
                      validator: customEditFormValidator
                    }
                  ],
                  initialValue: editBusFormInitialValues.vin
                }
              ]"
            />
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button
            form="editBusForm"
            type="primary"
            key="saveChanges"
            html-type="submit"
            :loading="editBusFormButtonLoading"
          >
            Save Changes
          </a-button>
        </template>
      </a-modal>
      <a-modal
        v-model="createFleetModalVisible"
        title="Create New Fleet"
        centered
        :afterClose="
          () => {
            this.createFleetForm.resetFields();
            this.uploadFileList = [];
            this.uploadButtonDisabled = false;
          }
        "
      >
        <a-form layout="vertical" id="createFleetForm" :form="createFleetForm" @submit="createFleet">
          <a-form-item label="Fleet Name">
            <a-input
              v-decorator="[
                'fleetName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter a fleet name!'
                    },
                    {
                      validator: customFleetNameValidator
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="Company">
            <a-select
              v-decorator="[
                'company',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select a company!'
                    }
                  ]
                }
              ]"
              :allowClear="true"
              placeholder="Select company"
            >
              <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <span slot="label"
              >Bus List
              <a-popover title="Bus List Format">
                <template slot="content">
                  <p>Please provide the list of buses as a JSON Array. For example:</p>
                  <p>[ { "busNumber": 285, "vin": 12345678901234568 } ]</p>
                  <p><b>Required Attributes:</b> busNumber, vin</p>
                  <p>
                    <b>TIP:</b> Convert CSV to JSON
                    <a href="https://csvjson.com/csv2json" target="_blank" rel="noopener noreferrer">
                      here.
                    </a>
                  </p>
                </template>
                <a-icon type="question-circle-o" />
              </a-popover>
            </span>
            <a-textarea
              allowClear
              placeholder="JSON Bus List"
              :auto-size="{ minRows: 5, maxRows: 10 }"
              v-decorator="[
                'busList',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please enter a list of buses!'
                    },
                    {
                      validator: customCreateFleetFormValidator
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item style="text-align: center">
            <a-upload
              accept=".csv"
              :headers="headers"
              :customRequest="dummyUploadRequest"
              @change="handleUploadChange"
              :fileList="uploadFileList"
              :multiple="false"
            >
              <a-button icon="upload" :disabled="uploadButtonDisabled">Upload CSV</a-button>
            </a-upload>
          </a-form-item>
        </a-form>
        <template slot="footer">
          <a-button form="createFleetForm" type="primary" html-type="submit" :loading="createFleetFormButtonLoading">
            Create Fleet
          </a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      fleetSearchForm: this.$form.createForm(this),
      editBusForm: this.$form.createForm(this),
      addBusForm: this.$form.createForm(this),
      createFleetForm: this.$form.createForm(this),
      addIndividualBusForm: this.$form.createForm(this),
      fleetData: [],
      uploadFileList: [],
      editBusFormInitialValues: {},
      addBusFormInitialValues: {},
      fleetDataLoading: false,
      editBusModalVisible: false,
      editBusFormButtonLoading: false,
      createFleetModalVisible: false,
      createFleetFormButtonLoading: false,
      addBusModalVisible: false,
      addBusFormButtonLoading: false,
      addIndividualBusModalVisible: false,
      uploadButtonDisabled: false,
      fleetEntriesFound: 0,
      headers: {
        authorization: "authorization-text"
      },
      fleetColumns: [
        {
          dataIndex: "entityId",
          title: "Fleet Name",
          align: "center"
        },
        {
          dataIndex: "company",
          title: "Company",
          align: "center"
        },
        {
          dataIndex: "numberOfBuses",
          title: "Number of Buses",
          align: "center"
        },
        {
          title: "Is Active",
          dataIndex: "isActive",
          align: "center",
          customRender: isActive => {
            if (isActive) {
              return "Yes";
            } else {
              return <p style="color:#f50; margin:0">No</p>;
            }
          },
          filters: [
            {
              text: "Yes",
              value: "true"
            },
            {
              text: "No",
              value: "false"
            }
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.isActive.toString() === value
        },
        {
          title: "Last Updated",
          dataIndex: "lastUpdated",
          align: "center"
        },
        {
          title: "Updated By",
          dataIndex: "updatedBy",
          align: "center"
        },
        {
          title: "Actions",
          scopedSlots: { customRender: "actions" },
          align: "center"
        }
      ],
      innerFleetColumns: [
        {
          dataIndex: "busNumber",
          title: "Bus Number",
          align: "center",
          sorter: (recordOne, recordTwo) => {
            let numberOne, numberTwo;
            if (recordOne.busNumber == "New VIN Found") {
              numberOne = Number.MAX_SAFE_INTEGER;
            } else {
              numberOne = recordOne.busNumber;
            }

            if (recordTwo.busNumber == "New VIN Found") {
              numberTwo = Number.MAX_SAFE_INTEGER;
            } else {
              numberTwo = recordTwo.busNumber;
            }
            return numberOne - numberTwo;
          }
        },
        {
          dataIndex: "vin",
          title: "VIN",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.vin.localeCompare(recordTwo.vin)
        },
        {
          title: "Last Updated",
          dataIndex: "revision",
          align: "center"
        },
        {
          title: "Actions",
          scopedSlots: { customRender: "actions" },
          align: "center"
        }
      ]
    };
  },
  props: ["masterCompanyMap", "AWS"],

  computed: {
    ...mapState(["UserName"]),

    // function to display the list of companies in the master company list.
    displayCompanies() {
      let companyList = [];
      this.masterCompanyMap.forEach((companyObject, companyName) => {
        companyList.push(companyName);
      });
      return companyList.sort();
    },

    handleFleetData() {
      // copy data over, and sort/filter it according to requirements.
      const data = this.fleetData;
      data.forEach(fleet => {
        if (fleet.lastUpdated) {
          fleet.lastUpdated = this.$moment(fleet.lastUpdated)
            .local()
            .format("YYYY-MM-DD HH:mm");
        } else {
          fleet.lastUpdated = "N/A";
        }
      });
      data.sort((recordOne, recordTwo) => {
        return recordOne.entityId.localeCompare(recordTwo.entityId);
      });
      return data;
    }
  },

  methods: {
    handleFleetSearch(e) {
      e.preventDefault();
      this.fleetSearchForm.validateFields((error, fieldValues) => {
        if (error) {
          return;
        }
        this.loadFleetData(fieldValues.company);
      });
    },

    editBus(event) {
      event.preventDefault();
      this.editBusForm.validateFields(async (error, fieldValues) => {
        if (error) {
          return;
        }
        try {
          this.editBusFormButtonLoading = true;
          let selectedBusKey = this.editBusFormInitialValues.key;
          let currentBusList = this.editBusFormInitialValues.currentBusList.filter(bus => bus.key !== selectedBusKey);
          let newBusRecord = {
            busNumber: fieldValues.busNumber.toString().trim(),
            vin: fieldValues.vin,
            revision: new Date().toISOString(),
            entityId: "VEH#" + fieldValues.vin.trim(),
            company: this.editBusFormInitialValues.company
          };
          currentBusList.push(newBusRecord);
          // remove the key before inserting the updated bus list into the database.
          currentBusList.forEach(bus => {
            delete bus.key;
          });
          var params = {
            objectType: "FLT",
            operation: "update",
            revision: new Date().toISOString(),
            entityId: this.editBusFormInitialValues.fleetName,
            region: this.masterCompanyMap.get(this.editBusFormInitialValues.company).region
          };
          var body = {
            busList: JSON.stringify(currentBusList)
          };
          await this.sendRequest(params, body, "post");
          await this.issueServerUpdate(this.editBusFormInitialValues.company, this.editBusFormInitialValues.fleetName);
          this.editBusFormButtonLoading = false;
          this.editBusForm.resetFields();
          this.editBusModalVisible = false;
          this.$message.success("Successfully updated bus and issued server program update!");
          this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
        } catch (error) {
          this.editBusFormButtonLoading = false;
          this.editBusForm.resetFields();
          this.editBusModalVisible = false;
          this.$message.error("Error updating bus: " + (error.message ? error.message : error));
          this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
          return;
        }
      });
    },

    createFleet(event) {
      event.preventDefault();
      this.createFleetForm.validateFields(async (error, fieldValues) => {
        if (error) {
          return;
        }
        try {
          this.createFleetFormButtonLoading = true;
          let busList = JSON.parse(fieldValues.busList.replace(/\s+/g, ""));
          busList.forEach(busRecord => {
            busRecord.company = fieldValues.company;
            busRecord.entityId = "VEH#" + busRecord.vin;
            busRecord.revision = new Date();
          });
          var params = {
            objectType: "FLT",
            operation: "add",
            entityId: "FLT#" + fieldValues.fleetName,
            company: fieldValues.company,
            revision: new Date().toISOString(),
            region: this.masterCompanyMap.get(fieldValues.company).region
          };
          var body = {
            busList: JSON.stringify(busList)
          };
          await this.sendRequest(params, body, "post");
          this.createFleetFormButtonLoading = false;
          this.createFleetForm.resetFields();
          this.createFleetModalVisible = false;
          this.$message.success("Successfully created new fleet!");
          this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
          this.$emit("refresh-company-list");
        } catch (error) {
          this.createFleetFormButtonLoading = false;
          if (error == "The conditional request failed") {
            this.$message.error("Error creating new fleet - Fleet Name already exists.");
          } else {
            this.$message.error("Error creating new fleet: " + (error.message ? error.message : error));
            this.createFleetForm.resetFields();
            this.createFleetModalVisible = false;
            this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
          }
          return;
        }
      });
    },

    dummyUploadRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("Upload Successful");
      }, 0);
    },

    sendRequest(params, body, requestType) {
      // before making an API request, check to make sure user has access to perform the action / credentials need to be refreshed.
      return new Promise((resolve, reject) => {
        this.AWS.config.credentials.get(async credentialError => {
          if (credentialError) {
            if (credentialError.name === "NotAuthorizedException") {
              reject(
                new Error(
                  "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                )
              );
            } else {
              reject(credentialError.message);
            }
          } else {
            try {
              var aws4 = require("aws4");
              // before sending the appropriate request, add the current user's username to the parameters.
              params.username = this.UserName;
              let paramsUrl = this.createParamsUrl(params);
              switch (requestType) {
                case "get": {
                  let request = {
                    host: "v9ovun9ana.execute-api.us-west-2.amazonaws.com",
                    method: "GET",
                    url: "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/configure?" + paramsUrl,
                    path: "/prod/configure?" + paramsUrl,
                    service: "execute-api"
                  };
                  let signedRequest = aws4.sign(request, {
                    secretAccessKey: this.AWS.config.credentials.secretAccessKey,
                    accessKeyId: this.AWS.config.credentials.accessKeyId,
                    sessionToken: this.AWS.config.credentials.sessionToken
                  });
                  // delete unsafe headers from the signed request.
                  delete signedRequest.headers["Host"];
                  delete signedRequest.headers["Content-Length"];

                  let response = await this.$axios(signedRequest);
                  let items = response.data.Items;
                  resolve(items);
                  break;
                }
                case "post": {
                  let request = {
                    host: "v9ovun9ana.execute-api.us-west-2.amazonaws.com",
                    method: "POST",
                    url: "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/configure?" + paramsUrl,
                    path: "/prod/configure?" + paramsUrl,
                    service: "execute-api",
                    data: body,
                    body: JSON.stringify(body),
                    headers: {
                      "content-type": "application/json"
                    }
                  };
                  let signedRequest = aws4.sign(request, {
                    secretAccessKey: this.AWS.config.credentials.secretAccessKey,
                    accessKeyId: this.AWS.config.credentials.accessKeyId,
                    sessionToken: this.AWS.config.credentials.sessionToken
                  });
                  // delete unsafe headers from the signed request.
                  delete signedRequest.headers["Host"];
                  delete signedRequest.headers["Content-Length"];

                  let response = await this.$axios(signedRequest);
                  let responseData = response.data;
                  resolve(responseData);
                  break;
                }
                default:
                  break;
              }
            } catch (error) {
              // if no response is available, means it is a network error.
              if (!error.response) {
                reject(new Error("Network Error. Please try again!"));
              } else {
                let response = error.response;
                if (response.status == 403) {
                  reject(
                    "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                  );
                } else {
                  reject(response.data.message);
                }
              }
            }
          }
        });
      });
    },

    async loadFleetData(selectedCompany) {
      this.fleetDataLoading = true;
      this.fleetData = [];
      var promiseArray = [];
      if (selectedCompany) {
        var params = {
          company: selectedCompany,
          objectType: "FLT",
          operation: "get",
          region: this.masterCompanyMap.get(selectedCompany).region
        };
        promiseArray.push(this.sendRequest(params, {}, "get"));
      } else {
        this.masterCompanyMap.forEach((valueObject, company) => {
          let params = {
            company: company,
            region: valueObject.region,
            objectType: "FLT",
            operation: "get"
          };
          promiseArray.push(this.sendRequest(params, {}, "get"));
        });
      }
      try {
        let dataArray = await Promise.all(promiseArray);
        let data = dataArray.flat(Infinity);
        // check if no data is returned; display a message to user in that case.
        if (!data.length) {
          throw new Error("No data available for selected company!");
        }
        // iterate over the data and assign key to each record.
        data.forEach((fleetObject, outerIndex) => {
          fleetObject.key = outerIndex + 1;
          fleetObject.busList = JSON.parse(fleetObject.busList);
          fleetObject.numberOfBuses = fleetObject.busList.length;
          fleetObject.busList.forEach((bus, innerIndex) => {
            bus.key = innerIndex + 1;
            bus.revision = this.$moment(bus.revision)
              .local()
              .format("YYYY-MM-DD HH:mm");
          });
        });
        this.fleetData = data;
        this.fleetEntriesFound = data.length;
      } catch (error) {
        this.$message.error("Error loading fleet data: " + (error.message ? error.message : error));
        this.fleetDataLoading = false;
        return;
      }
      this.fleetDataLoading = false;
    },

    addBuses(formEvent) {
      formEvent.preventDefault();
      this.addBusForm.validateFields(async (error, fieldValues) => {
        if (error) {
          return;
        }
        try {
          this.addBusFormButtonLoading = true;
          let currentBusList = this.addBusFormInitialValues.currentBusList;
          let addedBusList = JSON.parse(fieldValues.busList.replace(/\s+/g, ""));
          addedBusList.forEach(busRecord => {
            busRecord.company = this.addBusFormInitialValues.company;
            busRecord.entityId = "VEH#" + busRecord.vin;
            busRecord.revision = new Date();
          });
          currentBusList.push(...addedBusList);
          // remove the key before inserting the updated bus list into the database.
          currentBusList.forEach(busRecord => {
            if (busRecord.key) {
              delete busRecord.key;
            }
          });
          var params = {
            objectType: "FLT",
            operation: "update",
            entityId: this.addBusFormInitialValues.fleetName,
            revision: new Date().toISOString(),
            region: this.masterCompanyMap.get(this.addBusFormInitialValues.company).region
          };
          var body = {
            busList: JSON.stringify(currentBusList)
          };
          await this.sendRequest(params, body, "post");
          await this.issueServerUpdate(this.addBusFormInitialValues.company, this.addBusFormInitialValues.fleetName);
          this.addBusFormButtonLoading = false;
          this.addBusForm.resetFields();
          this.addBusModalVisible = false;
          this.$message.success("Successfully added buses and issued server program update!");
          this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
        } catch (error) {
          this.addBusFormButtonLoading = false;
          this.addBusForm.resetFields();
          this.addBusModalVisible = false;
          this.$message.error("Error adding buses: " + (error.message ? error.message : error));
          this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
          return;
        }
      });
    },

    addIndividualBus(formEvent) {
      formEvent.preventDefault();
      this.addIndividualBusForm.validateFields(async (error, fieldValues) => {
        if (error) {
          return;
        }
        try {
          let currentBusList = this.addBusForm.getFieldValue("busList");
          // if a chargerList already exists, add to the list.
          if (currentBusList) {
            let jsonArray = JSON.parse(currentBusList);
            jsonArray.push({
              busNumber: fieldValues.busNumber.trim(),
              vin: fieldValues.vin.trim()
            });
            this.addBusForm.setFieldsValue({ busList: JSON.stringify(jsonArray) });
          } else {
            let jsonArray = [];
            jsonArray.push({
              busNumber: fieldValues.busNumber.trim(),
              vin: fieldValues.vin.trim()
            });
            this.addBusForm.setFieldsValue({ busList: JSON.stringify(jsonArray) });
          }
          this.addIndividualBusModalVisible = false;
        } catch (error) {
          this.$message.error("Error adding single bus - " + (error.message ? error.message : error));
          this.addIndividualBusModalVisible = false;
          return;
        }
      });
    },

    async updateIsActive(fleetRecord, isActive) {
      try {
        this.fleetDataLoading = true;
        var params = {
          objectType: "FLT",
          operation: isActive ? "enable" : "disable",
          entityId: fleetRecord.entityId,
          company: fleetRecord.company,
          isActive: isActive,
          revision: new Date().toISOString(),
          region: this.masterCompanyMap.get(fleetRecord.company).region
        };
        await this.sendRequest(params, {}, "get");
        if (isActive) {
          this.$message.success("Successfully enabled fleet!");
        } else {
          this.$message.success("Successfully disabled fleet!");
        }
        this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
        this.$emit("refresh-company-list");
      } catch (error) {
        this.$message.error("Error updating isActive: " + (error.message ? error.message : error));
        this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
        return;
      }
    },

    async deleteBus(record, busRecord) {
      try {
        this.fleetDataLoading = true;
        const newBusList = record.busList.filter(bus => {
          return bus.key !== busRecord.key;
        });
        // remove the key before inserting the new bus list into the database.
        newBusList.forEach(bus => {
          delete bus.key;
        });
        var params = {
          objectType: "FLT",
          operation: "update",
          entityId: record.entityId,
          revision: new Date().toISOString(),
          region: this.masterCompanyMap.get(record.company).region
        };
        var body = {
          busList: JSON.stringify(newBusList)
        };
        await this.sendRequest(params, body, "post");
        await this.issueServerUpdate(record.company, record.entityId);
        this.$message.success("Successfully deleted bus and issued server program update!");
        this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
      } catch (error) {
        this.$message.error("Error deleting bus: " + (error.message ? error.message : error));
        this.loadFleetData(this.fleetSearchForm.getFieldValue("company"));
        return;
      }
    },

    issueServerUpdate(companyName, fleet) {
      return new Promise((resolve, reject) => {
        var AWSIoTData = require("aws-iot-device-sdk");
        this.AWS.config.credentials.get(identityError => {
          if (!identityError) {
            try {
              let region = this.masterCompanyMap.get(companyName).region;
              let depotList = this.masterCompanyMap.get(companyName).depots;
              let publishCounter = 0;
              const mqttClient = AWSIoTData.device({
                region: region,
                host: "a3ijg5gjke8m6j-ats.iot." + region + ".amazonaws.com",
                clientId: "elmsWebsiteClient_" + this.UserName,
                protocol: "wss",
                debug: false,
                reconnectPeriod: 0,
                accessKeyId: this.AWS.config.credentials.accessKeyId,
                secretKey: this.AWS.config.credentials.secretAccessKey,
                sessionToken: this.AWS.config.credentials.sessionToken
              });
              mqttClient.on("close", () => {
                // end the client connection again in case connection was automatically closed.
                mqttClient.end();
                resolve();
              });
              mqttClient.on("connect", () => {
                // on connection, firstly subscribe to update confirmation topic.
                // next, publish message to update the requested attribute and set a timeout period to end the client connection.
                let messagePayload = {
                  updateAttribute: "busList",
                  fleetId: fleet,
                  timestamp: new Date()
                };
                var messagesPublished = new Promise(resolve => {
                  depotList.forEach((depot, counter, array) => {
                    mqttClient.publish(
                      "ioc/" + depot + "/elmsServer/cmd/issueServerUpdate",
                      JSON.stringify(messagePayload),
                      { qos: 1 }
                    );
                    if (counter === array.length - 1) {
                      resolve();
                    }
                  });
                });
                messagesPublished.then(() => {
                  setTimeout(() => {
                    // once timeout is reached, end the client connection.
                    mqttClient.end();
                  }, this.getConnectionTimeout(depotList.length));
                });
              });
              mqttClient.on("packetsend", packet => {
                if (packet.cmd === "publish") {
                  publishCounter += 1;
                  if (publishCounter >= depotList.length) {
                    mqttClient.end();
                  }
                }
              });
              mqttClient.on("error", () => {
                throw new Error("Error thrown by MQTT Client.");
              });
            } catch (error) {
              reject(error);
            }
          } else {
            if (identityError.name === "NotAuthorizedException") {
              reject(
                new Error(
                  "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                )
              );
            } else {
              reject(new Error(identityError.message));
            }
          }
        });
      });
    },

    customCreateFleetFormValidator(rule, value, callback) {
      if (value) {
        try {
          let jsonList = JSON.parse(value);
          let vinList = [],
            busNumberList = [];
          jsonList.forEach(busRecord => {
            if (!busRecord.vin || !busRecord.busNumber) {
              throw new Error("One of the required attributes missing.");
            } else if (busRecord.vin.length != 17) {
              throw new Error("VIN for bus number " + busRecord.busNumber + " must be 17 characters.");
            } else {
              if (vinList.includes(busRecord.vin)) {
                callback("Duplicate VIN found: " + busRecord.vin + ".");
              } else {
                vinList.push(busRecord.vin);
              }
              if (busNumberList.includes(busRecord.busNumber)) {
                callback("Duplicate Bus Number found: " + busRecord.busNumber + ".");
              } else {
                busNumberList.push(busRecord.busNumber);
              }
            }
          });
          callback();
        } catch (error) {
          switch (error.name) {
            case "SyntaxError":
              callback("Invalid JSON Format. Error: " + error.message);
              break;
            case "TypeError":
              callback("Invalid input. Error: Input must be a JSON array.");
              break;
            default:
              callback("Error: " + error.message);
              break;
          }
        }
      } else {
        callback();
      }
    },

    customAddFormValidator(rule, value, callback) {
      if (value) {
        try {
          let jsonList = JSON.parse(value);
          jsonList.forEach(busRecord => {
            if (!busRecord.vin || !busRecord.busNumber) {
              throw new Error("One of the required attributes missing.");
            } else if (busRecord.vin.length != 17) {
              throw new Error("VIN for bus number " + busRecord.busNumber + " must be 17 characters.");
            } else {
              let currentBusNumber, currentVIN;
              if (
                this.addBusFormInitialValues.currentBusList.some(currentBus => {
                  currentBusNumber = currentBus.busNumber;
                  return currentBus.vin === busRecord.vin;
                })
              ) {
                throw new Error(
                  "Duplicate VIN for new bus number " +
                    busRecord.busNumber +
                    " and current bus number " +
                    currentBusNumber +
                    "."
                );
              } else if (
                this.addBusFormInitialValues.currentBusList.some(currentBus => {
                  currentVIN = currentBus.vin;
                  return currentBus.busNumber === busRecord.busNumber.toString();
                })
              ) {
                throw new Error(
                  "Duplicate bus numbers for new VIN " + busRecord.vin + " and current VIN " + currentVIN + "."
                );
              }
            }
          });
          callback();
        } catch (error) {
          switch (error.name) {
            case "SyntaxError":
              callback("Invalid JSON Format. Error: " + error.message);
              break;
            case "TypeError":
              callback("Invalid input. Error: Input must be a JSON array.");
              break;
            default:
              callback("Error: " + error.message);
              break;
          }
        }
      } else {
        callback("Bus List cannot be empty!");
      }
    },

    customFleetNameValidator(rule, value, callback) {
      if (value) {
        if (
          this.fleetData.some(fleet => {
            return fleet.entityId === "FLT#" + value;
          })
        ) {
          callback("Fleet with this name already exists.");
        }
        callback();
      } else {
        callback();
      }
    },

    customEditFormValidator(rule, value, callback) {
      switch (rule.field) {
        case "busNumber":
          if (value) {
            let currentVIN;
            if (
              this.editBusFormInitialValues.currentBusList.some(currentBus => {
                currentVIN = currentBus.vin;
                return currentBus.busNumber === value.toString() && currentBus.key != this.editBusFormInitialValues.key;
              })
            ) {
              callback("Duplicate bus number - Currently assigned to VIN " + currentVIN + ".");
            }
          } else {
            callback("Please enter a bus number!");
          }
          callback();
          break;
        case "vin":
          if (value) {
            if (value.length != 17) {
              callback("VIN must be exactly 17 characters.");
            } else {
              let currentBusNumber;
              if (
                this.editBusFormInitialValues.currentBusList.some(currentBus => {
                  currentBusNumber = currentBus.busNumber;
                  return currentBus.vin === value && currentBus.key != this.editBusFormInitialValues.key;
                })
              ) {
                callback("Duplicate VIN - Currently under bus number " + currentBusNumber + ".");
              }
            }
          } else {
            callback("Please enter a VIN!");
          }
          callback();
          break;
      }
    },

    setEditBusFormModal(fleetRecord, busRecord) {
      // set the initial values of the form before displaying it.
      this.editBusFormInitialValues.fleetName = fleetRecord.entityId;
      this.editBusFormInitialValues.busNumber = busRecord.busNumber;
      this.editBusFormInitialValues.vin = busRecord.vin;
      this.editBusFormInitialValues.currentBusList = fleetRecord.busList;
      this.editBusFormInitialValues.key = busRecord.key;
      this.editBusFormInitialValues.company = busRecord.company;
      this.editBusModalVisible = true;
    },

    setAddBusFormModal(fleetRecord) {
      this.addBusFormInitialValues.fleetName = fleetRecord.entityId;
      this.addBusFormInitialValues.currentBusList = fleetRecord.busList;
      this.addBusFormInitialValues.company = fleetRecord.company;
      this.addBusModalVisible = true;
    },

    handleUploadChange(info) {
      let fileList = [...info.fileList];
      // check the status of the file upload.
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
        // once file is uploaded successfully, parse the content and convert to JSON.
        let reader = new FileReader();
        reader.onload = e => {
          try {
            const csv2json = require("csvjson-csv2json");
            const json = csv2json(e.target.result);
            if (this.addBusModalVisible) {
              this.addBusForm.setFieldsValue({ busList: JSON.stringify(json) });
            } else {
              this.createFleetForm.setFieldsValue({ busList: JSON.stringify(json) });
            }
          } catch (error) {
            if (this.addBusModalVisible) {
              this.addBusForm.setFieldsValue({ busList: "Invalid CSV Format" });
            } else {
              this.createFleetForm.setFieldsValue({ busList: "Invalid CSV Format" });
            }
          }
        };
        reader.readAsText(info.file.originFileObj);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }

      // disable upload button after one upload.
      if (fileList.length != 0) {
        this.uploadButtonDisabled = true;
      } else {
        this.uploadButtonDisabled = false;
        if (this.addBusModalVisible) {
          this.addBusForm.resetFields(["busList"]);
        } else {
          this.createFleetForm.resetFields(["busList"]);
        }
      }

      this.uploadFileList = fileList;
    },

    getConnectionTimeout(dataSize) {
      if (dataSize === 1) {
        return 2000;
      } else if (dataSize <= 5) {
        return 5000;
      } else if (dataSize <= 30) {
        return 10000;
      } else {
        return 12500;
      }
    },

    createParamsUrl(paramsObject) {
      var paramsUrl = "";
      var counter = 0;
      var totalCount = Object.keys(paramsObject).length;
      for (var key in paramsObject) {
        if (paramsObject.hasOwnProperty(key)) {
          paramsUrl += key + "=" + paramsObject[key];
          if (counter != totalCount - 1) {
            paramsUrl += "&";
          }
          counter += 1;
        }
      }
      return paramsUrl.replace("#", "%23");
    }
  }
};
</script>

<style>
.ant-form-item {
  margin-bottom: 5px;
}

.p {
  margin: 0;
}

.a-button {
  margin: 0 auto;
  display: block;
}
</style>
